import { ActionType, ActionTypes } from '../../actions/index';
import { ISeatInCartRequestModel } from '../../actions/fetch';
import { ISeatMatchRequestModel } from '../../classes/request-model';
import * as redux from 'redux';

export interface ISeatMapResultModel {
    requestingSeatmap: boolean;
    requestingSeatPaths: boolean;
    requestingBackgroundPaths: boolean;
    seatMapMatchFilter: ISeatMatchRequestModel;
}

let defaultSeatMapResultModel = {
    seatMapMatchFilter: null,
    requestingSeatmap: false,
    requestingBackgroundPaths: false,
    requestingSeatPaths: false
};

export { defaultSeatMapResultModel };

export function seatMapResultModel(state: ISeatMapResultModel = defaultSeatMapResultModel
    , action) {
    switch (action.type) {
        case ActionTypes.REQUEST_SEATMAP:
            return { ...state, seatMapMatchFilter: action.value, requestingSeatmap: true };
        case ActionTypes.RECEIVE_SEATMAP:
            return {
                ...state,
                requestingSeatmap: false
            };
        case ActionTypes.REQUEST_SEATMAP_BACKGROUND:
            return { ...state, requestingBackgroundPaths: true };
        case ActionTypes.RECEIVE_SEATMAP_BACKGROUND:
            return {
                ...state,
                requestingBackgroundPaths: false
            };
        case ActionTypes.REQUEST_SEATMAP_PATHS:
            return { ...state, requestingSeatPaths: true };
        case ActionTypes.RECEIVE_SEATMAP_PATHS:
            return {
                ...state,
                requestingSeatPaths: false
            };
        default:
            return state;
    }
};
